// 联系表单提交查看工具

export interface FormSubmission {
  id: string
  name: string
  email: string
  company?: string
  phone?: string
  message: string
  timestamp: string
  timestampFormatted: string
  source?: string
}

// 获取所有表单提交
export const getAllSubmissions = (): FormSubmission[] => {
  try {
    const submissions = localStorage.getItem('contact_submissions')
    return submissions ? JSON.parse(submissions) : []
  } catch (error) {
    console.error('Error reading submissions:', error)
    return []
  }
}

// 导出为CSV格式
export const exportSubmissionsToCSV = (): string => {
  const submissions = getAllSubmissions()
  
  if (submissions.length === 0) {
    return 'No submissions found'
  }

  // CSV标题行
  const headers = [
    'ID',
    'Name', 
    'Email', 
    'Company', 
    'Phone', 
    'Message', 
    'Submit Time',
    'Source'
  ]

  // CSV数据行
  const rows = submissions.map(sub => [
    sub.id,
    `"${sub.name}"`,
    sub.email,
    `"${sub.company || ''}"`,
    sub.phone || '',
    `"${sub.message.replace(/"/g, '""')}"`, // 转义引号
    sub.timestampFormatted,
    sub.source || ''
  ])

  // 合并为CSV字符串
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.join(','))
  ].join('\n')

  return csvContent
}

// 下载CSV文件
export const downloadSubmissionsCSV = () => {
  const csvContent = exportSubmissionsToCSV()
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', `contact_submissions_${new Date().toISOString().split('T')[0]}.csv`)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

// 清除所有提交记录
export const clearAllSubmissions = () => {
  if (confirm('确定要清除所有联系表单记录吗？此操作不可恢复。')) {
    localStorage.removeItem('contact_submissions')
    console.log('✅ 所有联系表单记录已清除')
    return true
  }
  return false
}

// 在控制台显示所有提交的格式化表格
export const showSubmissionsTable = () => {
  const submissions = getAllSubmissions()
  
  if (submissions.length === 0) {
    console.log('📋 暂无联系表单提交记录')
    return
  }

  console.group(`📊 联系表单提交记录 (共 ${submissions.length} 条)`)
  
  // 按时间倒序显示（最新的在前）
  const sortedSubmissions = submissions.sort((a, b) => 
    new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
  )

  sortedSubmissions.forEach((submission, index) => {
    console.group(`📧 提交 #${index + 1} - ${submission.name}`)
    console.log('🕐 时间:', submission.timestampFormatted)
    console.log('👤 姓名:', submission.name)
    console.log('📧 邮箱:', submission.email)
    console.log('🏢 公司:', submission.company || '未提供')
    console.log('📞 电话:', submission.phone || '未提供')
    console.log('📍 来源:', submission.source || '未知')
    console.log('💬 消息:', submission.message)
    console.log('🆔 ID:', submission.id)
    console.groupEnd()
  })
  
  console.log('\n📥 导出CSV: downloadSubmissionsCSV()')
  console.log('🗑️ 清除记录: clearAllSubmissions()')
  console.groupEnd()
}

// 将这些函数添加到全局窗口对象，方便在控制台使用
if (typeof window !== 'undefined') {
  (window as any).contactSubmissions = {
    getAll: getAllSubmissions,
    show: showSubmissionsTable,
    exportCSV: exportSubmissionsToCSV,
    downloadCSV: downloadSubmissionsCSV,
    clear: clearAllSubmissions
  }
  
  // 启动时显示提示
  console.log('🔧 联系表单管理工具已加载')
  console.log('📊 查看提交: contactSubmissions.show()')
  console.log('📥 下载CSV: contactSubmissions.downloadCSV()')
}










